import { Col, Row } from 'reactstrap';
import 'utils/jsdocTypes';

/**
 * @typedef {Object} Props
 * @property {AdminCustomerDetails} customer
 */

/**
 * @function InvoiceBillTo
 * @param {Props} props
 * @type {React.JSX.Element}
 */
const InvoiceBillTo = ({ customer }) => {
  return (
    <>
      <Row>
        <Col sm="12" style={{
          textTransform: "uppercase",
          paddingTop: "2rem",
          borderBottom: "2px solid #5D728C"
        }}>
          Bill to
            </Col>
      </Row>

      <Row>
        <Col sm="12">
          <span style={{
            fontSize: "clamp(20px, 6vw, 20px)"
          }}>{customer.firstname} {customer.lastname}</span>
        </Col>
      </Row>
      <Row>
        <Col sm="12">
          {customer.address1}
        </Col>
      </Row>
      {customer.address2 &&
        <Row>
          <Col sm="12">
            {customer.address2}
          </Col>
        </Row>
      }
      <Row>
        <Col sm="12">
          {customer.city}, {customer.state}, {customer.zip}
        </Col>
      </Row>
    </>
  );
};

export default InvoiceBillTo;